import { useContext } from "react"
import EnabledFeaturesContext from "./EnabledFeaturesContext"

export default () => {
    const flags = useContext(EnabledFeaturesContext);
    return flags;
}